<template>
  <router-view />
</template>

<script>
export default {
  beforeCreate: function () {
    document
      .querySelector("body")
      .setAttribute("style", "margin:0; padding:0;");
  },
};
</script>

<style lang="less">
body {
  margin: 0;
  .el-select-dropdown {
    .el-select-dropdown__list {
      .el-select-dropdown__item {
        display: block;
      }
    }
  }
}
html {
  font-size: 62.5%; //这里就是10/16x100%=62.5% 也就是默认10px的字号
}
ul,li{
  list-style: none;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // background-color: #f6f9fe;
}

</style>
